import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQS, CONTACT } from "../data";
import { Reveal, SectionLabel } from "./Reveal";

export const Faq = () => {
  return (
    <section
      id="faq"
      className="relative bg-secondary py-24 sm:py-32"
      data-testid="faq"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <SectionLabel>Veelgestelde vragen</SectionLabel>
            <Reveal>
              <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-ink leading-[1.02]">
                Veelgestelde vragen over softwash en buitenreiniging
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-5 text-muted-foreground leading-relaxed">
                Hier vind je antwoorden op veelgestelde vragen over onze
                werkwijze, geschikte ondergronden, kosten en het verwachte
                resultaat. Staat jouw vraag er niet tussen?{" "}
                <a
                  href={CONTACT.phoneHref}
                  className="font-semibold text-teal underline-offset-4 hover:underline"
                >
                  Neem gerust contact met ons op
                </a>{" "}
                voor persoonlijk advies.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-${i}`}
                  className="border-b border-border"
                >
                  <AccordionTrigger className="text-left font-display text-lg sm:text-xl font-semibold text-ink hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-[15px] leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
